import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { vertices_of_face } from '../../lattice';
import { State } from '../../state';
import {
    uil_get_edges_of_vertex,
    uil_get_vertices_of_edge,
    uil_is_object_fixed,
    uil_is_object_visible,
} from '../../ui_logic';
import BarButton from '@components/bar-button';
import { inside } from '@vaaas/fpts/array';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import edge_to_face_tangency_svg from '../../../assets/img/SVG_icons/Top/editing_model/edge_to_face_tangency.svg';
import { img } from '@phi/components';
import { make_selected_edges_tangent_to_selected_faces } from '@frontend/uid_continuity';
import EdgeToFaceTangencyTooltip from './EdgeToFaceTangencyTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const EdgeToFaceTangencyIcon = edge_to_face_tangency_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Tangent edge w.r.t. face';
        },

        disabled() {
            return !this.state.loaded
                || !this.state.editing_edge_tangent_mode
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || !this.only_edges_and_faces_selected
                || !this.at_least_one_edge_touches_face;
        },

        only_edges_and_faces_selected() {
            return this.state.selected_vertices_count === 0
                && this.state.selected_edges_count > 0
                && this.state.selected_faces_count > 0;
        },

        at_least_one_edge_touches_face() {
            this.state.selected_faces_count;
            return uid_selected_faces.keys().some((fid) =>
                uid_selected_edges
                    .keys()
                    .filter(x => !uil_is_object_fixed(x))
                    .some(eid => {
                        // Find common vertex
                        const vid = vertices_of_face(fid)
                            .find(inside(uil_get_vertices_of_edge(eid)));
                        if (vid === undefined)
                            return false;
                        const visible_edges = uil_get_edges_of_vertex(vid)
                            .filter(uil_is_object_visible);
                        return visible_edges.length >= 3;
                    }));
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                make_selected_edges_tangent_to_selected_faces();
        },
    },

    render() {
        return h(BarButton, {
            id: 'edge-to-face-tangency-button',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 8,
            disabled: this.disabled,
            tippy: 'left',
            help: 'edge_to_face_tangency',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edge_to_face_tangency_svg, this.alt),
            tooltip: EdgeToFaceTangencyTooltip,
        });
    },
});
